/**
 * ApiLogsClient
 * SignalR client for API Logs Hub (/hubs/api-logs)
 * Handles real-time API request log streaming with filtering
 */
import { BaseLogsClient } from './BaseLogsClient';
/**
 * API logs hub client
 */
export class ApiLogsClient extends BaseLogsClient {
    constructor(baseUrl, getToken, options = {}) {
        const hubUrl = `${baseUrl}/hubs/api-logs`;
        super(hubUrl, getToken, options);
    }
    /**
     * Setup server-side method handlers
     */
    setupServerMethods() {
        if (!this.connection)
            return;
        // Receive real-time API log entries
        this.connection.on('ReceiveApiLog', (log) => {
            this.addLogToBuffer(log);
            this.emit('log', log);
        });
    }
    /**
     * Subscribe to API logs with filter
     */
    async subscribe(filter = {}) {
        this.currentFilter = filter;
        await this.invoke('SubscribeToApiLogs', filter.serviceNames || [], filter.minDurationMs || null, filter.pathFilter || null);
        this.isSubscribed = true;
    }
    /**
     * Unsubscribe from API logs
     */
    async unsubscribe() {
        await this.invoke('UnsubscribeFromApiLogs');
        this.isSubscribed = false;
        this.currentFilter = null;
    }
    /**
     * Get recent API logs
     */
    async getRecent(limit = 100) {
        return await this.invoke('GetRecentApiLogs', limit);
    }
}
//# sourceMappingURL=ApiLogsClient.js.map